import { memo } from 'react'

const ActionBar = memo(({ children }) => children) // extends memo?

ActionBar.defaultProps = {
  type: 'ActionBar'
}

export default ActionBar
